module.exports = __webpack_public_path__ + "static/paperplane-04507d37e5a26d44a8cee0b3ac237b0d.png";